export default __webpack_public_path__ + "static/media/tokens icon  white (1).22c018ca.svg";